export const POST_SORT_STORE_KEY = 'POST_SORT_STORE';
export const COMMENT_SORT_STORE_KEY = 'COMMENT_SORT_STORE_KEY';
